import { StaffRole } from '@mygate/common';

// Presentation metadata only. Route guards and backend permissions enforce access.
export const navigationGroups = [
  {
    name: 'Übersicht',
    items: [
      { path: '/dashboard', name: 'Dashboard', admin: false },
      { path: '/analytics', name: 'Analytics', admin: true },
    ],
  },
  {
    name: 'Kunden & Prüfung',
    items: [
      { path: '/users', name: 'Kunden', admin: false },
      { path: '/kyc-manual-review', name: 'KYC-Prüfung', admin: true },
      { path: '/residence-reviews', name: 'Wohnsitznachweise', admin: true },
      { path: '/tradevest-onboarding', name: 'Tradevest-Onboarding', admin: true },
    ],
  },
  {
    name: 'Banking & Abrechnung',
    items: [
      { path: '/transaction-queue', name: 'Zahlungswarteschlange', admin: true },
      { path: '/subscriptions', name: 'Abos & Abrechnung', admin: true },
      { path: '/card-renewals', name: 'Kartenverlängerungen', admin: true },
      { path: '/three-ds', name: '3DS-Freigaben', admin: true },
      { path: '/finapi-oversight', name: 'Bankverbindungen', admin: true },
    ],
  },
  {
    name: 'Investments',
    items: [
      { path: '/assets', name: 'Assets', admin: true },
      { path: '/issuers', name: 'Emittenten', admin: true },
    ],
  },
  {
    name: 'Kommunikation & Wachstum',
    items: [
      { path: '/broadcasts', name: 'Broadcasts', admin: true },
      { path: '/notifications', name: 'Benachrichtigungen', admin: true },
      { path: '/referrals', name: 'Empfehlungen', admin: true },
    ],
  },
  {
    name: 'Verwaltung',
    items: [
      { path: '/staff', name: 'Mitarbeiter', admin: true },
      { path: '/app-settings', name: 'App-Einstellungen', admin: true },
      { path: '/legal-documents', name: 'Rechtliche Dokumente', admin: true },
    ],
  },
];

export function getNavigation(role: StaffRole | undefined) {
  if (!role) return [];
  return navigationGroups
    .map(group => ({ ...group, items: group.items.filter(item => !item.admin || role === StaffRole.ADMIN) }))
    .filter(group => group.items.length > 0);
}

export function getActiveNavigationPath(pathname: string): string {
  if (/^\/(kyc-cases|wallet-balances|tradevest-log)\//.test(pathname)) return '/users';
  return (
    navigationGroups
      .flatMap(group => group.items)
      .find(item => pathname === item.path || pathname.startsWith(`${item.path}/`))?.path ?? '/dashboard'
  );
}

export function getPageName(pathname: string): string {
  if (pathname.startsWith('/kyc-cases/')) return 'KYC-Fälle';
  if (pathname.startsWith('/wallet-balances/')) return 'Wallet-Bestände';
  if (pathname.startsWith('/tradevest-log/')) return 'Tradevest-Protokoll';
  if (pathname === '/assets/new') return 'Asset anlegen';
  if (pathname.startsWith('/assets/')) return 'Asset-Details';
  if (/^\/issuers\/[^/]+\/brand$/.test(pathname)) return 'Markenauftritt';
  if (pathname.startsWith('/issuers/')) return 'Emittenten-Assets';
  return navigationGroups.flatMap(group => group.items).find(item => item.path === pathname)?.name ?? 'Backoffice';
}
